module.exports = __webpack_public_path__ + "static/media/cover-mobile-411x93.2c1fd693.webp";